import { Globals } from "@ortho-next/three-base";
import { Vector2, Vector3 } from "three";
import { Line2, LineMaterial } from "three/addons";
import { Consts } from "../../Utils/Consts.js";
export class SingleLine2 extends Line2 {
    constructor(name, viewType, color, A = new Vector3(0, 0, 0), B = new Vector3(0, 0, 1), dashSize = 0, gapSize = 0, lineWidth = 3) {
        super();
        this.material = new LineMaterial({
            linewidth: lineWidth,
            resolution: new Vector2(Globals.canvasContainer.clientWidth, Globals.canvasContainer.clientHeight),
            color: color,
            gapSize: gapSize,
            dashSize: dashSize,
            dashScale: 1,
            dashed: gapSize !== 0 && dashSize !== 0
        });
        if (this.material.dashed) {
            this.material.defines["USE_DASH"] = "";
        }
        this.name = name;
        this.interceptedByRaycaster = false;
        this._A = A.clone();
        this._B = B.clone();
        this.update();
        this.material.uniforms["dashScale"].value = 1 / Consts.scaleFactorPoints;
    }
    get A() {
        return this._A;
    }
    set A(value) {
        this._A.copy(value);
        this.update();
    }
    get B() {
        return this._B;
    }
    set B(value) {
        this._B.copy(value);
        this.update();
    }
    setAB(A, B) {
        this._A.copy(A);
        this._B.copy(B);
        this.update();
    }
    update() {
        this.geometry.setPositions([this._A.x, this._A.y, this._A.z, this._B.x, this._B.y, this._B.z]);
        this.computeLineDistances();
        this.geometry.computeBoundingSphere();
    }
    updateResolution(width, height) {
        this.material.resolution.set(width, height);
    }
}
//# sourceMappingURL=SingleLine2.js.map